export default __webpack_public_path__ + "static/media/bee color 1.a9a66a0d.svg";